import script from "./ServiceClientView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceClientView.vue?vue&type=script&setup=true&lang=js"

import "./ServiceClientView.vue?vue&type=style&index=0&id=f28b9d0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f28b9d0c"]])

export default __exports__